import { Button, Modal } from "react-bootstrap";
import useModalStore from "../StatesStore/ModalStore";
import { useEffect, useState } from "react";

function RemoveFollowerFollowingModal() {
  const { title, data, closeModal } = useModalStore();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const handleImageError = (e, userData) => {
    const avatarInitials = userData?.userName
      ? userData?.userName[0]?.toUpperCase()
      : userData?.displayName?.toUpperCase();
    e.target.onerror = null; // Prevents infinite loop in case fallback also fails
    e.target.src = `https://ui-avatars.com/api/?name=${avatarInitials}`;
  };
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isSmallScreen ? (
    <Modal
      className="removeFollowerFollowingModal"
      show
      centered
      onHide={closeModal}
    >
      <style jsx>
        {`
          .removeFollowerFollowingModal .modal-content {
            width: 21.5rem;
            margin: 0 auto;
            border-radius: 14px;
          }
        `}
      </style>
      <Modal.Body
        className="d-flex flex-column align-items-center"
        style={{ padding: "1.25rem 1rem", gap: "14px" }}
      >
        <div
          className="d-flex flex-column align-items-center"
          style={{ gap: "12px" }}
        >
          <img
            src={
              data?.userData?.photo ||
              `https://ui-avatars.com/api/?name=${data?.userData?.userName[0]?.toUpperCase()}`
            }
            onError={(e) => {
              handleImageError(e, data?.userData);
            }}
            width={"60px"}
            height={"60px"}
            style={{ borderRadius: "12px" }}
            alt=""
          />
          <div
            style={{
              fontFamily: "Inter",
              fontWeight: "600",
              fontSize: "18px",
              lineHeight: "100%",
              letterSpacing: "0%",
              textAlign: "center",
              verticalAlign: "middle",
              color: "#000000",
            }}
          >
            {data?.modalHeaderText}
          </div>
          {data?.modalBodyText()}
        </div>
        <div
          className="d-flex flex-column align-items-center"
          style={{ gap: "6px", width: "100%" }}
        >
          <div
            onClick={async () => {
              await data?.handleConfirm();
              closeModal();
            }}
            style={{
              width: "100%",
              height: "46px",
              borderRadius: "10px",
              padding: "12px 24px",
              gap: "10px",
              backgroundColor: "#005FDA",
              cursor: "pointer",
            }}
            className="d-flex justify-content-center align-items-center"
          >
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: "500",
                fontSize: "18px",
                lineHeight: "100%",
                letterSpacing: "0%",
                textAlign: "center",
                color: "white",
              }}
            >
              {data?.confirmButtonText}
            </div>
          </div>
          <div
            onClick={closeModal}
            style={{
              width: "100%",
              height: "46px",
              borderRadius: "10px",
              padding: "12px 24px",
              gap: "10px",
              border: "1px solid #005FDA",
              cursor: "pointer",
            }}
            className="d-flex justify-content-center align-items-center"
          >
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: "500",
                fontSize: "18px",
                lineHeight: "100%",
                letterSpacing: "0%",
                textAlign: "center",
                color: "#005FDA",
              }}
            >
              Cancel
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  ) : (
    <Modal show centered onHide={closeModal}>
      <Modal.Body style={{ padding: "2rem" }}>
        <div className="d-flex flex-column">
          <div className="d-flex w-100 justify-content-between">
            <div className="h4">{data?.modalHeaderText}</div>
            <button
              type="button"
              style={{
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                width: "27px",
                height: "27px",
                background: "#FFFFFF",
                border: "1px solid #FF3B30",
                boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                borderRadius: "25px",
                flex: "none",
                order: "1",
                flexGrow: "0",
              }}
              onClick={closeModal}
            >
              <svg
                style={{ width: "11px" }}
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke="#FF3B30"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
          {data?.modalBodyText()}
        </div>
        <div className="d-flex flex-column gap-2 w-100 mt-3">
          <Button
            style={{
              borderRadius: "10px",
              backgroundColor: "#005FDA",
              color: "white",
            }}
            onClick={async () => {
              await data?.handleConfirm();
              closeModal();
            }}
          >
            {data?.confirmButtonText}
          </Button>
          <Button
            style={{
              border: "1px solid #005FDA",
              borderRadius: "10px",
              backgroundColor: "white",
              color: "#005FDA",
            }}
            onClick={closeModal}
          >
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default RemoveFollowerFollowingModal;
